import type { YouthParticipantId } from './youthParticipants'
import { appStorage } from './betaStorage'
export type LeoSharedTask = { id: string; title: string; assignedTo: 'Casey Morgan'; createdBy: 'Lillian Carter'; done: boolean }
export type LeoShoppingItem = { id: string; text: string; addedBy: 'Lillian Carter'; done: boolean }
export type LeoListItem = { id: string; text: string; list: string; addedBy: 'Lillian Carter'; done: boolean }
export type LeoTeamUpdate = { id: string; from: string; text: string; createdAt: string }
export type LeoTeamMessage = { id: string; from: string; to: string; text: string; createdAt: string }
export type LeoGroupChat = { id: string; name: string; members: string[]; createdBy: string; messages: LeoTeamMessage[] }
export type YouthMessagesState = Pick<LeoSharedDemoState, 'messages' | 'groups'>

export type LeoSharedDemoState = {
  tasks: LeoSharedTask[]
  shopping: LeoShoppingItem[]
  lists: LeoListItem[]
  updates: LeoTeamUpdate[]
  messages: LeoTeamMessage[]
  groups: LeoGroupChat[]
}

const KEY = 'schub.leo.sharedDemo.v1'
const YOUTH_MESSAGES_KEY = 'schub.youth.messages.v1'
export const LEO_SHARED_UPDATED = 'schub-leo-shared-updated'

const seed: LeoSharedDemoState = {
  tasks: [
    { id: 'task-seed-1', title: 'Practise “I need a break” after school', assignedTo: 'Casey Morgan', createdBy: 'Lillian Carter', done: false },
    { id: 'task-seed-2', title: 'Pack Leo’s swimming bag for Thursday', assignedTo: 'Casey Morgan', createdBy: 'Lillian Carter', done: false },
  ],
  shopping: [
    { id: 'shop-seed-1', text: 'Bananas', addedBy: 'Lillian Carter', done: false },
    { id: 'shop-seed-2', text: 'Leo’s preferred yoghurt', addedBy: 'Lillian Carter', done: false },
    { id: 'shop-seed-3', text: 'Bread', addedBy: 'Lillian Carter', done: true },
  ],
  lists: [
    { id: 'list-seed-1', list: 'Community outing', text: 'Headphones', addedBy: 'Lillian Carter', done: false },
    { id: 'list-seed-2', list: 'Community outing', text: 'Water bottle', addedBy: 'Lillian Carter', done: false },
  ],
  updates: [
    { id: 'update-seed-1', from: 'Lillian Carter', text: 'Leo slept well. Please keep the after-school transition low demand and offer a snack before homework.', createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString() },
    { id: 'update-seed-2', from: 'Casey Morgan', text: 'Yesterday Leo chose headphones and quiet space before homework with one prompt.', createdAt: new Date(Date.now() - 22 * 60 * 60 * 1000).toISOString() },
  ],
  messages: [
    { id: 'msg-seed-1', from: 'Lillian Carter', to: 'Casey Morgan', text: 'Hi Casey — can you please grab the yoghurt and bananas on the way home today?', createdAt: new Date(Date.now() - 90 * 60 * 1000).toISOString() },
    { id: 'msg-seed-2', from: 'Casey Morgan', to: 'Lillian Carter', text: 'Yes, I’ll pick them up after Leo’s activity.', createdAt: new Date(Date.now() - 80 * 60 * 1000).toISOString() },
  ],
  groups: [{ id:'group-seed-1', name:'Leo Care Team', members:['Lillian Carter','Casey Morgan','Mia Roberts','Jordan Blake','Olivia Chen'], createdBy:'Lillian Carter', messages:[{ id:'group-msg-1', from:'Lillian Carter', to:'Leo Care Team', text:'Please use this group for shared changes that affect Leo’s whole team.', createdAt:new Date(Date.now()-3*60*60*1000).toISOString() }] }],
}

const lizzieMessageSeed: YouthMessagesState = {
  messages: [
    { id: 'lizzie-msg-seed-1', from: 'Lillian Carter', to: 'Mia Roberts', text: 'Lizzie used her NIXI “Help please” choice before preschool and was proud when it spoke for her.', createdAt: new Date(Date.now() - 70 * 60 * 1000).toISOString() },
    { id: 'lizzie-msg-seed-2', from: 'Olivia Chen', to: 'Mia Roberts', text: 'The first–then play cards worked well. Keep the next step short and visible.', createdAt: new Date(Date.now() - 20 * 60 * 60 * 1000).toISOString() },
  ],
  groups: [{ id: 'lizzie-group-seed-1', name: 'Lizzie Care Team', members: ['Lillian Carter', 'Mia Roberts', 'Olivia Chen'], createdBy: 'Lillian Carter', messages: [{ id: 'lizzie-group-msg-1', from: 'Lillian Carter', to: 'Lizzie Care Team', text: 'Please use this group for shared changes that affect Lizzie’s support.', createdAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString() }] }],
}

function normalise(state: any): LeoSharedDemoState {
  return { ...seed, ...state, groups: Array.isArray(state?.groups) ? state.groups : seed.groups }
}
function emit() { if (typeof window !== 'undefined') window.dispatchEvent(new Event(LEO_SHARED_UPDATED)) }
export function loadLeoSharedDemo(): LeoSharedDemoState {
  try { const raw=appStorage.getItem(KEY); if(!raw){ appStorage.setItem(KEY,JSON.stringify(seed)); return seed } return normalise(JSON.parse(raw)) } catch { return seed }
}
export function saveLeoSharedDemo(next: LeoSharedDemoState) { appStorage.setItem(KEY, JSON.stringify(next)); emit() }
export function updateLeoSharedDemo(change: (current: LeoSharedDemoState) => LeoSharedDemoState) { saveLeoSharedDemo(change(loadLeoSharedDemo())) }
export function addLeoTask(title: string) { const value=title.trim(); if(!value)return; updateLeoSharedDemo(s=>({...s,tasks:[{id:`task-${Date.now()}`,title:value,assignedTo:'Casey Morgan',createdBy:'Lillian Carter',done:false},...s.tasks]})) }
export function addLeoShoppingItem(text: string) { const value=text.trim(); if(!value)return; updateLeoSharedDemo(s=>({...s,shopping:[{id:`shop-${Date.now()}`,text:value,addedBy:'Lillian Carter',done:false},...s.shopping]})) }
export function addLeoListItem(list: string, text: string) { const value=text.trim(); if(!value)return; updateLeoSharedDemo(s=>({...s,lists:[{id:`list-${Date.now()}`,list:list.trim()||'General',text:value,addedBy:'Lillian Carter',done:false},...s.lists]})) }
export function addLeoUpdate(text: string, from='Lillian Carter') { const value=text.trim(); if(!value)return; updateLeoSharedDemo(s=>({...s,updates:[{id:`update-${Date.now()}`,from,text:value,createdAt:new Date().toISOString()},...s.updates]})) }
export function addLeoMessage(to: string, text: string, from='Lillian Carter') { const value=text.trim(); if(!value)return; updateLeoSharedDemo(s=>({...s,messages:[{id:`msg-${Date.now()}`,from,to,text:value,createdAt:new Date().toISOString()},...s.messages]})) }
export function createLeoGroup(name:string,members:string[],createdBy:string){ const value=name.trim(); if(!value||members.length<2)return; updateLeoSharedDemo(s=>({...s,groups:[{id:`group-${Date.now()}`,name:value,members:[...new Set([createdBy,...members])],createdBy,messages:[]},...s.groups]})) }
export function addLeoGroupMessage(groupId:string,text:string,from:string){ const value=text.trim(); if(!value)return; updateLeoSharedDemo(s=>({...s,groups:s.groups.map(g=>g.id===groupId?{...g,messages:[...g.messages,{id:`group-msg-${Date.now()}`,from,to:g.name,text:value,createdAt:new Date().toISOString()}]}:g)})) }
export function toggleLeoSharedItem(kind:'tasks'|'shopping'|'lists',id:string){ updateLeoSharedDemo(s=>({...s,[kind]:s[kind].map((item:any)=>item.id===id?{...item,done:!item.done}:item)})) }

function youthMessagesKey(participantId: YouthParticipantId) { return `${YOUTH_MESSAGES_KEY}.${participantId}` }
function messageSeed(participantId: YouthParticipantId): YouthMessagesState {
  return participantId === 'u-jnr' ? lizzieMessageSeed : { messages: seed.messages, groups: seed.groups }
}
export function loadYouthMessages(participantId: YouthParticipantId): YouthMessagesState {
  if (participantId === 'u-leo') {
    const state = loadLeoSharedDemo()
    return { messages: state.messages, groups: state.groups }
  }
  const fallback = messageSeed(participantId)
  try {
    const raw = appStorage.getItem(youthMessagesKey(participantId))
    if (!raw) {
      appStorage.setItem(youthMessagesKey(participantId), JSON.stringify(fallback))
      return fallback
    }
    const stored = JSON.parse(raw) as Partial<YouthMessagesState>
    return {
      messages: Array.isArray(stored.messages) ? stored.messages : fallback.messages,
      groups: Array.isArray(stored.groups) ? stored.groups : fallback.groups,
    }
  } catch {
    return fallback
  }
}
function saveYouthMessages(participantId: YouthParticipantId, next: YouthMessagesState) {
  if (participantId === 'u-leo') {
    updateLeoSharedDemo(state => ({ ...state, messages: next.messages, groups: next.groups }))
    return
  }
  appStorage.setItem(youthMessagesKey(participantId), JSON.stringify(next))
  emit()
}
function updateYouthMessages(participantId: YouthParticipantId, change: (current: YouthMessagesState) => YouthMessagesState) {
  saveYouthMessages(participantId, change(loadYouthMessages(participantId)))
}
export function addYouthMessage(participantId: YouthParticipantId, to: string, text: string, from: string) {
  const value = text.trim()
  if (!value) return
  updateYouthMessages(participantId, state => ({ ...state, messages: [{ id: `msg-${Date.now()}`, from, to, text: value, createdAt: new Date().toISOString() }, ...state.messages] }))
}
export function createYouthGroup(participantId: YouthParticipantId, name: string, members: string[], createdBy: string) {
  const value = name.trim()
  if (!value || members.length < 2) return
  updateYouthMessages(participantId, state => ({ ...state, groups: [{ id: `group-${Date.now()}`, name: value, members: [...new Set([createdBy, ...members])], createdBy, messages: [] }, ...state.groups] }))
}
export function addYouthGroupMessage(participantId: YouthParticipantId, groupId: string, text: string, from: string) {
  const value = text.trim()
  if (!value) return
  updateYouthMessages(participantId, state => ({ ...state, groups: state.groups.map(group => group.id === groupId ? { ...group, messages: [...group.messages, { id: `group-msg-${Date.now()}`, from, to: group.name, text: value, createdAt: new Date().toISOString() }] } : group) }))
}

